import { Row as RGSRow, Col as RGSCol } from 'react-grid-system';
import styled from 'styled-components';

export const Row = styled(RGSRow)`
  margin-bottom: ${({ theme }) => theme.spacing.x3};
`;

export const Col = styled(RGSCol)``;
